var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeftClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.516 3.516-1.594-1.594c-0.7078-0.7078-1.922-0.2062-1.922 0.7922v5.161c0 0.6234 0.5016 1.125 1.125 1.125h5.161c1.003 0 1.505-1.214 0.7969-1.922l-1.444-1.444c1.627-1.627 3.877-2.634 6.361-2.634 4.969 0 9 4.031 9 9 0 4.969-4.031 9-9 9-1.912 0-3.684-0.5953-5.142-1.612-0.6797-0.4734-1.612-0.3094-2.091 0.3703-0.4781 0.6797-0.3094 1.612 0.3703 2.091 1.95 1.355 4.317 2.152 6.862 2.152 6.628 0 12-5.372 12-12 0-6.628-5.372-12-12-12-3.314 0-6.314 1.345-8.484 3.516zm8.484 2.484c-0.6234 0-1.125 0.5016-1.125 1.125v4.875c0 0.3 0.1172 0.5859 0.3281 0.7969l3.375 3.375c0.4406 0.4406 1.153 0.4406 1.589 0 0.4359-0.4406 0.4406-1.153 0-1.589l-3.047-3.047v-4.411c0-0.6234-0.5016-1.125-1.125-1.125z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeftClock);
export default __webpack_public_path__ + "static/media/rotate-left-clock.c4c623685494292ef83ffff53b6cd0a3.svg";
export { ForwardRef as ReactComponent };